import React, { memo } from "react";
// @ts-ignore
import { Button } from "@lululemon/ui-library";
import { useDeviceType } from "@lululemon/ecom-site/src/util/with-device-characteristics";
import { Menu } from "../../molecules";

// Styles
import styles from "./SortFilter.module.scss";

interface SortFilterProps {
  sortOptions: SortOption[];
  appliedFiltersCount: number;
  onSortMenuSelect: (optionSelected: { label: string; key: string }) => void;
  onMobileSortClick: () => void;
}

/**
 * @SortFilter Component for rendering a sort filter with options based.
 * @param {SortFilterProps} props - The props for the SortFilter component.
 * @returns {JSX.Element} JSX element representing the SortFilter component.
 */

export const SortFilter: React.FC<SortFilterProps> = memo((props) => {
  const {
    sortOptions,
    appliedFiltersCount,
    onSortMenuSelect,
    onMobileSortClick,
  } = props;

  const filterCount =
    appliedFiltersCount > 0 ? `\u00A0(${appliedFiltersCount})` : "";

  const { deviceType } = useDeviceType();
  const isDesktopDevice = deviceType.isDesktop;

  return (
    <div className={`${styles.sortFilterWrapper} row end-sm`}>
      {!isDesktopDevice && (
        <Button
          className={styles.filterSortBtn}
          onClick={onMobileSortClick}
          data-testid="filterSortButton"
        >
          {`Filter & Sort${filterCount}`}
        </Button>
      )}

      {isDesktopDevice && (
        <Menu
          options={sortOptions}
          label="Sort by"
          onChange={onSortMenuSelect}
        />
      )}
    </div>
  );
});

SortFilter.displayName = "SortFilter";
